import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';
import Footer from '../Layout/Footer';

const Login = () => {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!identifier || !password) {
      toast.error('Please fill in all fields');
      return;
    }

    setLoading(true);
    const result = await login(identifier, password);
    setLoading(false);

    if (result.success) {
      navigate('/dashboard');
    }
  };

  return (
    <>
      <div className="auth-page">
        <div className="auth-shell">
          <div className="auth-side">
            <div className="auth-brand-badge">Coinspire</div>
            <h1 className="auth-title">Welcome back</h1>
            <p className="auth-description">
              Access your trading dashboard, monitor performance, and manage your account securely.
            </p>

            <div className="auth-feature-list">
              <div className="auth-feature-item">
                <span className="auth-feature-dot" />
                <span>Real-time trading dashboard</span>
              </div>
              <div className="auth-feature-item">
                <span className="auth-feature-dot" />
                <span>Secure account access</span>
              </div>
              <div className="auth-feature-item">
                <span className="auth-feature-dot" />
                <span>Portfolio and balance tracking</span>
              </div>
            </div>
          </div>

          <div className="auth-card">
            <div className="auth-card-header">
              <p className="auth-kicker">Sign In</p>
              <h2 className="auth-card-title">Login to your account</h2>
              <p className="auth-card-subtitle">
                Enter your email or phone number and password to continue.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="auth-form">
              <div className="auth-field">
                <label className="auth-label">Email or Phone Number</label>
                <input
                  type="text"
                  value={identifier}
                  onChange={(e) => setIdentifier(e.target.value)}
                  className="auth-input"
                  placeholder="Enter your email or phone number"
                  disabled={loading}
                />
              </div>

              <div className="auth-field">
                <label className="auth-label">Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="auth-input"
                  placeholder="Enter your password"
                  disabled={loading}
                />
              </div>

              <button type="submit" className="auth-submit-btn" disabled={loading}>
                {loading ? 'Logging in...' : 'Login'}
              </button>
            </form>

            <p className="auth-footer-text">
              Don&apos;t have an account?{' '}
              <Link to="/register" className="auth-footer-link">
                Register
              </Link>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Login;